import { createSlice } from '@reduxjs/toolkit';
import { Product } from '@src/pages/MarketPlace';

interface MarketplaceState {
	product: Product | null;
	cart: Product[];
}

const initialState: MarketplaceState = {
	product: null,
	cart: [],
};

export const marketplaceSlice = createSlice({
	name: 'marketplace',
	initialState,
	reducers: {
		setProduct: (state, action) => {
			state.product = action.payload;
		},
		setCart: (state, action) => {
			state.cart = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setProduct, setCart } = marketplaceSlice.actions;

export default marketplaceSlice.reducer;
